export const demoViewerNavigation: any[] = [
  {
    id: 'resources',
    title: 'resources',
    subtitle: '',
    type: 'group',
    icon: 'heroicons_outline:home',
    classes: {
      wrapper: 'hidden',
    },
    children: [
      {
        id: 'demonstrations',
        title: 'demo-list',
        titlePt: 'demonstrações',
        titleEn: 'demonstrations',
        titleEs: 'demonstraciones',
        type: 'basic',
        icon: 'mat_outline:cloud_done',
        link: '/demo-list',
      },
    ],
  },
];
